import { eventService } from "@/services/api/event.service";
import { eventModel } from "@/models/api/event.model";
import { sessionHelper, sharedHelper, alertHelper } from "@/utils";
import i18n from "@/i18n";
export const EVENT_MODULE = "api/event";
export const state = {
  list: { data: [], pagination: { pageNumber: 1, pageSize: 15, total: 0 } },
  details: {},
  listError: false,
  detailError: false,
  status: { list: true, detail: true, save: true },
  listRequest: 0,
  detailRequest: 0,
};
function requireSuccess(result) {
  if (!result?.success)
    throw new Error(result?.message || i18n.t("label.eventRequestError"));
}
function errorAlert(error) {
  alertHelper.alertError({
    message: sharedHelper.getErrorMessage(error),
    title: i18n.t("message.error"),
  });
}
async function write({ commit }, method, args, successKey) {
  if (sessionHelper.getPermissionLevel("event_admin") !== 2) return null;
  commit("requesting", "save");
  try {
    const result = await eventService[method](...args);
    requireSuccess(result);
    commit("finished", "save");
    alertHelper.alertSuccess({
      message: i18n.t(successKey, [i18n.t("module.event")]),
    });
    return result;
  } catch (error) {
    commit("finished", "save");
    errorAlert(error);
    return null;
  }
}
export const actions = {
  async getAllEvent({ state, commit }, { filter = {} } = {}) {
    commit("requesting", "list");
    const request = state.listRequest;
    if (sessionHelper.getPermissionLevel("event_admin") < 1) {
      commit("clearList");
      return null;
    }
    try {
      const result = await eventService.getAll(filter);
      requireSuccess(result);
      if (!Array.isArray(result.data))
        throw new Error(i18n.t("label.eventRequestError"));
      if (request === state.listRequest) commit("listSuccess", result);
      return result;
    } catch (error) {
      if (request === state.listRequest) commit("listFailure");
      return null;
    }
  },
  async getEvent({ state, commit }, { uuid }) {
    commit("requesting", "detail");
    const request = state.detailRequest;
    if (sessionHelper.getPermissionLevel("event_admin") < 1) {
      commit("detailFailure");
      return null;
    }
    try {
      const result = await eventService.show(uuid);
      requireSuccess(result);
      const payload = Array.isArray(result.data)
        ? result.data.find((item) => item.uuid === uuid)
        : result.data?.event || result.data;
      if (payload?.uuid !== uuid)
        throw new Error(i18n.t("label.eventRequestError"));
      if (request === state.detailRequest) commit("detailSuccess", payload);
      return result;
    } catch (error) {
      if (request === state.detailRequest) commit("detailFailure");
      return null;
    }
  },
  createEvent(context, { data }) {
    return write(context, "store", [data], "message.createXSuccess");
  },
  updateEvent(context, { data }) {
    return write(context, "update", [data], "message.updateXSuccess");
  },
  updateEventActiveStatus(context, { uuid, isActive }) {
    return write(
      context,
      "updateActiveStatus",
      [uuid, isActive],
      "message.updateXSuccess",
    );
  },
  deleteEvent(context, { uuid }) {
    return write(context, "softDelete", [uuid], "message.deleteXSuccess");
  },
};
export const mutations = {
  requesting(state, type) {
    state.status[type] = false;
    if (type === "list") {
      state.listRequest++;
      state.listError = false;
    }
    if (type === "detail") {
      state.detailRequest++;
      state.detailError = false;
      state.details = {};
    }
  },
  finished(state, type) {
    state.status[type] = true;
  },
  clearList(state) {
    state.list.data = [];
    state.list.pagination = { pageNumber: 1, pageSize: 15, total: 0 };
    state.status.list = true;
  },
  listSuccess(state, result) {
    state.list.data = result.data.map(eventModel);
    state.list.pagination = result.pagination
      ? sharedHelper.apiPaginationAdapter(result.pagination)
      : { pageNumber: 1, pageSize: 15, total: result.data.length };
    state.status.list = true;
  },
  listFailure(state) {
    state.listError = true;
    state.status.list = true;
  },
  detailSuccess(state, data) {
    state.details = eventModel(data);
    state.status.detail = true;
  },
  detailFailure(state) {
    state.details = {};
    state.detailError = true;
    state.status.detail = true;
  },
};
